export const PRIMARY_LOCATION = "PRIMARY";
export const FOOTER_LOCATION = "FOOTER";
export const TAYLORS_LOCATION = "TAYLORS";
